import machine from "../../assets/machine.png";
import {
  Badge,
  EffortsCard,
  EffortsContainer,
} from "../Efforts.screen/Efforts.styled";
import { NavLink } from "../FAQ/FAQ.styled";
import { MiniNav } from "../MoveIn.screen/MoveIn.styled";
import {
  CollectionHeader,
  CollectionMainContainer,
  FinalSection,
  SecondSection,
  SectionBadge,
} from "./collection.style";
import pipesCard from "../../assets/pipesCard.png";
import truck from "../../assets/truck.png";
import General from "../../stores/GeneralStore";
const CollectionNetwork = () => {
  return (
    <>
      <CollectionHeader>
        <div style={{ width: "80%", margin: "auto" }}>
          <MiniNav>
            <NavLink to="/">
              {General?.codeLabels["cm_home"]?.label !== undefined ? General?.codeLabels["cm_home"]?.label : "Home"}

            </NavLink>&nbsp;/&nbsp;
            <NavLink to="/">
              
              {General?.codeLabels["cm_mob_aboutus"]?.label !== undefined ? General?.codeLabels["cm_mob_aboutus"]?.label : "About Us"}

            </NavLink>&nbsp;/&nbsp;
            <NavLink to="/">
              
              {General?.codeLabels["cm_collectionnetwork"]?.label !== undefined ? General?.codeLabels["cm_collectionnetwork"]?.label : "Collection Network"}

            </NavLink>
          </MiniNav>
          <h1 style={{ color: "#fff" }}>
           
            {General?.codeLabels["cm_collectionnetwork"]?.label !== undefined ? General?.codeLabels["cm_collectionnetwork"]?.label : " Collection Network"}

            </h1>
        </div>
        <Badge>
          Our state-of the art collection network is a comprehensive system that
          aims to connect most of Ajman to a centralized hub for the collection
          of used water.
        </Badge>
      </CollectionHeader>
      <CollectionMainContainer>
        <EffortsContainer>
          <h2>How It Works</h2>
          <EffortsCard>
            <img src={pipesCard} alt="pipes card" />
            <p>
              The system that we have implemented covers an area of 30 square
              kilometres and has over 300km of pipelines serving up to 120,000
              properties in the area. The system relies on 21 basins that
              collect water from properties via a simple yet effective gravity
              sewer. <br />
              <br />
              The water is then transported through an intricate series of
              pipelines by one of our 22 pumping stations that are strategically
              placed around sectors in Ajman. The used water from the basins is
              channeled to a final pumping station where it is transferred
              directly to our innovative used water treatment plant to be safely
              treated and re-used.
            </p>
          </EffortsCard>
        </EffortsContainer>
        <SecondSection>
          <img src={machine} alt="machine" />
          <SectionBadge>
            <p>
              It is important that our system is kept running 24 hours a day, 7
              days a week, 365 days a year, therefore we have in place a
              stringent maintenace and monitoring practice to stop any faults
              before they happen. <br />
              <br />
              We therefore carry out continuous and very frequent preventive
              cleaning of the sewerage network. To do so, we use an innovative
              approach based on state of the art technologies, such as CCTV
              cameras and truck-mounted high-pressure water jetting equipment
              for example, to prevent any fault from taking place and we quickly
              dispatch our highly trained engineers to oversee the system on a
              daily basis.
            </p>
          </SectionBadge>
        </SecondSection>
        <FinalSection>
          <h2>Septik Tank Collection</h2>
          <EffortsCard>
            <p>
              In an Emirate that genuinely cares for sustainability, the
              installation of the underground used water collection network
              eliminates the inconveniences caused by septic tanks, tankers, and
              all related issues, and avoids potential public health issue and
              adverse environmental impact and pollution of the soil. <br />
              <br />
              However, the rising population of Ajman means that not all
              properties are connected to the collection network. For those
              properties, third-party sewage transportation companies take care
              of the collection of used water to our treatment plant. Nowadays,
              99 % of all tankers discharge at the dedicated tanker discharge
              facility at our treatment plant.
            </p>
            <img src={truck} alt="truck" />
          </EffortsCard>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <button
              style={{
                color: "#101e8e",
                background: "#eee",
                border: "none",
                padding: "1rem",
                cursor: "pointer",
              }}
            >
              <b>
                Our Team
              </b>
            </button>
            <button
              style={{
                color: "#101e8e",
                background: "#eee",
                border: "none",
                padding: "1rem",
                cursor: "pointer",
              }}
            >
              <b>
                
                {General?.codeLabels["cm_treatmentplant"]?.label !== undefined ? General?.codeLabels["cm_treatmentplant"]?.label : "Treatment Plant"}

              </b>
            </button>
          </div>
        </FinalSection>
      </CollectionMainContainer>
    </>
  );
};

export default CollectionNetwork;
